/* eslint-disable @typescript-eslint/no-explicit-any */
import { UUID } from "node:crypto";
import { baseApi } from "./baseApi";
import { ConfigurationChecklistResponse, SignatureDocumentResponse } from "@interfaces/response";
import { ChecklistDocuments, CheckListSignatureDocument } from "@interfaces/catalogs";

const catalogosApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getChecklistDocuments: build.query<ChecklistDocuments, { tax_system_id: UUID }>({
      query: ({ tax_system_id }) => `configuraciones/onboarding?tax_system_id=${tax_system_id}&code=ChecklistDocuments`,
      transformResponse: (response: ConfigurationChecklistResponse) => {
        return response.data;
      },
    }),
    getDocumentosFirma: build.query<CheckListSignatureDocument[], { tax_system_id: UUID }>({
      query: ({ tax_system_id }) => `configuraciones/onboarding?tax_system_id=${tax_system_id}&code=DocumentosFirma`,
      transformResponse: (response: SignatureDocumentResponse) => {
        return response.data;
      },
    }),
  }),
});

export const { useLazyGetChecklistDocumentsQuery, useLazyGetDocumentosFirmaQuery } = catalogosApi;
